export enum AnalyzerColoringMehod {
    None,
    HistoricalVolatility,
}
